import React, { useState } from 'react';
import { db } from './firebaseConfig';
import { collection, addDoc, doc, updateDoc } from 'firebase/firestore';

const OPTIONS = ["Github CI/CD", "Backup Firebase", "Homologação", "Docker"];

function NewProjectModal({ onClose, onSave, existingProject }) {
  const [data, setData] = useState(existingProject || { 
    name: '', description: '', requester: '', startDate: '', deadline: '', checklist: [] 
  });

  const toggleOption = (opt) => {
    setData(prev => ({
      ...prev,
      checklist: prev.checklist.includes(opt) ? prev.checklist.filter(i => i !== opt) : [...prev.checklist, opt]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (existingProject) {
        await updateDoc(doc(db, "projects", existingProject.id), data);
      } else {
        // CORREÇÃO: Novo projeto agora começa com "Estudo de Projeto"
        await addDoc(collection(db, "projects"), { 
          ...data, 
          status: 'Estudo de Projeto', 
          createdAt: new Date(),
          versionCount: 0 
        });
      }
      onSave();
    } catch (error) {
      console.error("Erro ao salvar projeto:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-lg shadow-2xl">
        <h2 className="text-xl font-bold mb-4 border-b pb-2 text-gray-800">
          {existingProject ? 'Editar Dados do Projeto' : 'Criar Novo Projeto'}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-1">Nome do Sistema/Projeto</label>
            <input className="w-full p-2 border rounded" value={data.name} onChange={e => setData({...data, name: e.target.value})} required />
          </div>
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-1">Solicitante</label>
            <input className="w-full p-2 border rounded" value={data.requester} onChange={e => setData({...data, requester: e.target.value})} />
          </div>
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-1">Descrição</label>
            <textarea className="w-full p-2 border rounded" rows="3" value={data.description} onChange={e => setData({...data, description: e.target.value})} />
          </div>
          <div className="flex gap-4">
            <div className="w-1/2">
              <label className="block text-sm font-bold text-gray-700 mb-1">Data de Início</label>
              <input type="date" className="w-full p-2 border rounded" value={data.startDate} onChange={e => setData({...data, startDate: e.target.value})} />
            </div>
            <div className="w-1/2">
              <label className="block text-sm font-bold text-gray-700 mb-1">Prazo/Término</label>
              <input type="date" className="w-full p-2 border rounded" value={data.deadline} onChange={e => setData({...data, deadline: e.target.value})} />
            </div>
          </div>
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Checklist</label>
            <div className="flex flex-wrap gap-2">
              {OPTIONS.map(opt => (
                <button type="button" onClick={() => toggleOption(opt)}
                  className={`px-3 py-1.5 rounded-full text-xs font-bold shadow-sm transition-all duration-200 border ${
                    data.checklist.includes(opt) 
                      ? 'bg-blue-600 text-white border-blue-600' 
                      : 'bg-gray-100 text-gray-600 border-gray-300'
                  }`}
                >{opt}</button>
              ))}
            </div>
          </div>
          <div className="flex justify-end gap-3 pt-6 border-t mt-6">
            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600 font-bold hover:bg-gray-100 rounded">Cancelar</button>
            <button type="submit" className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded font-bold shadow-md">{existingProject ? 'Salvar Alterações' : 'Criar Projeto'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
export default NewProjectModal;